export default __webpack_public_path__ + "static/media/Moneybarn_FOS.54c69372.pdf";